import * as Sentry from "@sentry/react";

/**
 * Reports an error to Sentry. Needed in framework error boundaries (e.g. TanStack Router's
 * `defaultErrorComponent`) that catch render/loader errors and would otherwise swallow them
 * before Sentry's global handlers can see them.
 */
export function captureException(error: unknown): void {
  Sentry.captureException(error);
}
